// Smooth scroll with custom duration
function smoothScroll(target, duration = 300) {
    const start = window.scrollY;
    const distance = target - start;
    const startTime = performance.now();

    function step(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const ease = 1 - Math.pow(1 - progress, 3);
        window.scrollTo(0, start + distance * ease);
        if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
}

// Refresh cart to avoid cache
function refreshCartDrawer(openAfter = false) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const sections = cartDrawer.getSectionsToRender().map(s => s.id);
  const localePrefix = window.location.pathname.split('/')[1];
  const baseUrl = localePrefix.length === 2 ? `/${localePrefix}` : '';

  fetch(`${baseUrl}/cart?sections=${sections.join(',')}`)
    .then(res => res.json())
    .then(sectionsData => {
      cartDrawer.renderContents({ sections: sectionsData });
      if (openAfter) cartDrawer.open();
    });
}

/* to uncomment when cart is part of the full experience -> avoid cached cart issue
window.addEventListener('pageshow', function(event) {
  if (event.persisted || performance.navigation.type === 2) {
    console.log(':: Updating cart ::');
    //refreshCartDrawer();
  }
});
*/

/******************************************************************************
 * Clear deposit product from cart on pages that contain our iframes.
 *
 * Background: the deposit product is auto-injected into the cart when a customer
 * starts a repurchase flow. Some pages (e.g. the welcome-back page) contain iframes
 * that interfere with Shopify cart attributes, which can corrupt the deposit order.
 * To avoid this, we proactively remove the deposit from the cart whenever the
 * customer lands on a page outside /cart.
 *
 * We match by variant_id (not product_id) because the deposit is a specific variant —
 * Shopify cart line items expose variant_id, and using it avoids accidentally removing
 * a different variant of the same product if one ever exists.
 ******************************************************************************/
const INJECTED_DEPOSIT_VARIANT_ID = 43245289603320;

if (!window.location.pathname.startsWith('/cart')) {
  
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const injectedItem = cart.items.find(item => item.variant_id === INJECTED_DEPOSIT_VARIANT_ID);
      console.log('[custom_script.js] checking cart for deposit', INJECTED_DEPOSIT_VARIANT_ID);

      if (injectedItem) {
        console.log('[custom_script.js] DEPOSIT PRODUCT FOUND: remove injected items called');
        
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: injectedItem.key, quantity: 0 })
        }).then(() => {
          return fetch('/cart.js').then(r => r.json());
        }).then(cart => {
          document.querySelectorAll('.cart-icon-bubble-count').forEach(el => {
            el.textContent = cart.item_count;
          });
          // also hide the count bubble if cart is now empty
          document.querySelectorAll('.cart__count').forEach(el => {
            el.style.display = cart.item_count === 0 ? 'none' : '';
          });
        });
        
      }
      else {
        console.log('[custom_script.js] DEPOSIT PRODUCT NOT FOUND');
      }
    });
}

/******************************************************************************
 * Consentmo cookie banner: message text.
 *
 * The banner is a shadow-DOM custom element (<csm-cookie-consent>). Its message
 * is a <span> inside p.cc-message, followed by the privacy policy link. The free
 * plan cannot edit the text per language, so we set the message, the three button
 * labels and the link label here, based on the page language. The link URL is NOT
 * touched: set it in the Consentmo admin. A MutationObserver keeps the text
 * applied if the banner re-renders.
 ******************************************************************************/
(function () {
  var MESSAGES = {
    nl: 'We gebruiken cookies om deze website te laten werken, het verkeer te meten en inhoud te personaliseren. Je kunt op elk moment accepteren, weigeren of je privacyvoorkeuren beheren.',
    en: 'We use cookies to run this website, measure traffic and personalise content. You can accept, decline or manage your privacy preferences at any time.',
    fr: 'Nous utilisons des cookies pour faire fonctionner ce site, mesurer le trafic et personnaliser le contenu. Vous pouvez à tout moment accepter, refuser ou gérer vos préférences de confidentialité.'
  };

  // Button and link labels. Keyed by the banner's own (language independent) classes.
  var LABELS = {
    nl: { settings: 'Voorkeuren', deny: 'Weigeren', allow: 'Accepteren', link: 'Privacybeleid' },
    en: { settings: 'Preferences', deny: 'Decline', allow: 'Accept', link: 'Privacy policy' },
    fr: { settings: 'Préférences', deny: 'Refuser', allow: 'Accepter', link: 'Politique de confidentialité' }
  };

  // Preferences dialog strings. Key = the exact Dutch text Consentmo renders
  // (whitespace collapsed). Values are [nl, en, fr]: nl rewrites the formal "u" to "je".
  // If Consentmo changes its wording a key stops matching and that string simply
  // stays in Dutch, so extend this list when that happens.
  var PREFS = {
    'Selecteer de soorten cookies die u accepteert': [
      'Cookievoorkeuren',
      'Cookie preferences',
      'Préférences cookies'
    ],
    'Selecteer welke cookies we kunnen gebruiken. Noodzakelijke cookies zijn altijd aan. U kunt uw keuzes op elk moment wijzigen in de cookie-instellingen.': [
      'Kies welke cookies we mogen gebruiken. Noodzakelijke cookies staan altijd aan. Je kunt je keuzes op elk moment wijzigen in de cookie-instellingen.',
      'Choose which cookies we can use. Necessary cookies are always on. You can change your choices at any time in the cookie settings.',
      'Choisissez les cookies que nous pouvons utiliser. Les cookies nécessaires sont toujours activés. Vous pouvez modifier vos choix à tout moment dans les paramètres des cookies.'
    ],
    'Noodzakelijke': ['Noodzakelijke', 'Necessary', 'Nécessaires'],
    'Statistische': ['Statistische', 'Statistics', 'Statistiques'],
    'Voorkeuren': ['Voorkeuren', 'Preferences', 'Préférences'],
    'Deze cookies zijn essentieel voor de juiste werking van de website en stellen kernfuncties in zoals beveiliging, navigatie en toegang tot beveiligde gebieden. Ze kunnen niet worden uitgeschakeld.': [
      'Deze cookies zijn essentieel voor de juiste werking van de website en stellen kernfuncties in zoals beveiliging, navigatie en toegang tot beveiligde gebieden. Ze kunnen niet worden uitgeschakeld.',
      "These cookies are essential for the website to work properly and enable core functions such as security, navigation and access to secure areas. They can't be switched off.",
      "Ces cookies sont essentiels au bon fonctionnement du site et activent des fonctions de base comme la sécurité, la navigation et l'accès aux zones protégées. Ils ne peuvent pas être désactivés."
    ],
    'Door anonieme gegevens te verzamelen, helpen deze cookies ons te begrijpen hoe bezoekers met de website omgaan, waardoor we de prestaties en gebruikerservaring kunnen verbeteren.': [
      'Door anonieme gegevens te verzamelen, helpen deze cookies ons te begrijpen hoe bezoekers met de website omgaan, waardoor we de prestaties en gebruikerservaring kunnen verbeteren.',
      'By collecting anonymous data, these cookies help us understand how visitors use the website, so we can improve performance and user experience.',
      "En collectant des données anonymes, ces cookies nous aident à comprendre comment les visiteurs utilisent le site, pour que nous puissions améliorer ses performances et l'expérience utilisateur."
    ],
    'Deze cookies volgen uw activiteit op websites om gepersonaliseerde advertenties en relevante content te leveren. Ze helpen ook de effectiviteit van onze marketingcampagnes te meten.': [
      'Deze cookies volgen je activiteit op websites om gepersonaliseerde advertenties en relevante content te leveren. Ze helpen ook de effectiviteit van onze marketingcampagnes te meten.',
      'These cookies track your activity across websites to deliver personalised ads and relevant content. They also help us measure how effective our marketing campaigns are.',
      "Ces cookies suivent votre activité sur les sites web pour proposer des publicités personnalisées et du contenu pertinent. Ils nous aident aussi à mesurer l'efficacité de nos campagnes marketing."
    ],
    'Deze cookies onthouden uw keuzes – zoals taalvoorkeuren of inloggegevens – om een meer gepersonaliseerde ervaring te bieden.': [
      'Deze cookies onthouden je keuzes, zoals taalvoorkeuren of inloggegevens, om een meer gepersonaliseerde ervaring te bieden.',
      'These cookies remember your choices, such as language preferences or login details, to give you a more personalised experience.',
      'Ces cookies retiennent vos choix, comme la langue ou vos identifiants, pour offrir une expérience plus personnalisée.'
    ],
    'Aangeboden door': ['Aangeboden door', 'Provided by', 'Fourni par']
  };
  var LANG_INDEX = { nl: 0, en: 1, fr: 2 };

  function fixPrefs(root, lang) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var tag = node.parentElement && node.parentElement.tagName;
      if (tag === 'STYLE' || tag === 'SCRIPT') continue;
      var key = node.nodeValue.replace(/\s+/g, ' ').trim();
      var entry = PREFS[key];
      if (entry && node.nodeValue !== entry[LANG_INDEX[lang]]) {
        node.nodeValue = entry[LANG_INDEX[lang]];
      }
    }
  }

  function pageLang() {
    var lang = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
    return MESSAGES[lang] ? lang : 'nl';
  }

  function setText(el, text) {
    if (el && el.textContent.trim() !== text) el.textContent = text;
  }

  function fixText(root) {
    var lang = pageLang();
    var labels = LABELS[lang];
    root.querySelectorAll('p.cc-message > span').forEach(function (span) {
      // Only touch the message span, not anything containing the policy link.
      if (span.querySelector('a')) return;
      setText(span, MESSAGES[lang]);
    });
    root.querySelectorAll('button.cc-settings').forEach(function (b) { setText(b, labels.settings); });
    root.querySelectorAll('button.cc-deny').forEach(function (b) { setText(b, labels.deny); });
    root.querySelectorAll('button.cc-allow').forEach(function (b) { setText(b, labels.allow); });
    root.querySelectorAll('a.cc-link').forEach(function (a) { setText(a, labels.link); });
    fixPrefs(root, lang);
  }

  var tries = 0;
  var finder = setInterval(function () {
    var host = document.querySelector('csm-cookie-consent');
    if (host && host.shadowRoot) {
      clearInterval(finder);
      var root = host.shadowRoot;
      fixText(root);
      new MutationObserver(function () { fixText(root); })
        .observe(root, { childList: true, subtree: true });
    } else if (++tries > 40) {
      clearInterval(finder);
    }
  }, 500);
})();

/******************************************************************************
 * "Cookie settings" link: any link whose URL ends in #cookie-settings (for example
 * a footer menu item) reopens the Consentmo preferences dialog instead of navigating.
 ******************************************************************************/
document.addEventListener('click', function (e) {
  var link = e.target.closest && e.target.closest('a[href$="#cookie-settings"]');
  if (!link) return;
  e.preventDefault();
  try {
    window.Consentmo.openDialog('preferences');
  } catch (err) {
    console.warn('[custom_script.js] Consentmo not ready', err);
  }
});